import React from 'react'
import Table, {
  TableBody,
  TableData,
  TableHeader,
  TableHeaderItem,
  TableRow,
} from 'components/Table'
import { useTranslation } from 'react-i18next'
import './BundlesTable.scss'
import Pagination from '../../../../components/Pagination'
import { BUNDLE_ITEMS_PER_PAGE, DATE_FORMAT } from '../../../../constant'
import { BundleModel } from '../../../../api/bundle/models/bundle.model'
import DateUtils from '../../../../utils/date'

const BundlesTable: React.FC<{
  pageNumber: number
  totalItemsCount: number
  data: BundleModel[]
  rowClick: (bundle: BundleModel) => void
  setPageNumber: (page: number) => void
}> = ({ pageNumber, totalItemsCount, data, rowClick, setPageNumber }) => {
  const { t } = useTranslation()

  if (!data.length) {
    return (
      <div className='BundlesTable__no-data'>
        <p>{t('bundle.noData')}</p>
      </div>
    )
  }

  return (
    <div className='BundlesTable__table'>
      <Table className='CommonTable'>
        <TableHeader sticky>
          <>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.id')}
            </TableHeaderItem>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.identifier')}
            </TableHeaderItem>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.commercialName')}
            </TableHeaderItem>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.status')}
            </TableHeaderItem>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.startDate')}
            </TableHeaderItem>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.endDate')}
            </TableHeaderItem>
          </>
        </TableHeader>

        <TableBody>
          {data.map((bundle, i: number) => (
            <TableRow
              key={i}
              className='CommonTable__data-row'
              onClick={() => rowClick(bundle)}
            >
              <>
                <TableData
                  key={`${i}-id`}
                  className='CommonTable__data-item BundlesTable__id-row'
                >
                  <p>{bundle.id ?? '-'}</p>
                </TableData>
                <TableData
                  key={`${i}-identifier`}
                  className='CommonTable__data-item'
                >
                  <p>{bundle.identifier ?? '-'}</p>
                </TableData>
                <TableData
                  key={`${i}-commercialName`}
                  className='CommonTable__data-item'
                >
                  <p>{bundle.commercialName ?? '-'}</p>
                </TableData>
                <TableData
                  key={`${i}-computedStatus`}
                  className='CommonTable__data-item'
                >
                  <p>{t<string>(`bundle.scheduleStatus.${bundle.computedStatus}`)}</p>
                </TableData>
                <TableData
                  key={`${i}-startDate`}
                  className='CommonTable__data-item'
                >
                  <p>{DateUtils.parseAndFormat(bundle.startDate, DATE_FORMAT)}</p>
                </TableData>
                <TableData
                  key={`${i}-endDate`}
                  className='CommonTable__data-item'
                >
                  <p>{DateUtils.parseAndFormat(bundle.endDate, DATE_FORMAT)}</p>
                </TableData>
              </>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Pagination
        activePage={pageNumber}
        itemsCountPerPage={BUNDLE_ITEMS_PER_PAGE}
        totalItemsCount={totalItemsCount}
        onChange={setPageNumber}
      />
    </div>
  )
}

export default BundlesTable
